import {Auth0Client} from "@auth0/auth0-spa-js";
import {Auth0AuthProvider} from "ra-auth-auth0";

export const getAuth0Client = () => {
    return new Auth0Client({
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        cacheLocation: 'localstorage',
        authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        },
    });
}

export const authProvider =  () => {
    return Auth0AuthProvider(getAuth0Client());
}